/**
 * A BatchGeoTable plugin that lazily links table data that contains links. For
 * example if the table had `<td>http://google.com</td>` it would convert that
 * to `<td><a href="http://google.com">http://google.com</a></td>`.
 *
 * It only links data once per rowupdate event and has a debouncer so linkifying
 * does not happen too much.
 */
(function () {
  var RowLinkifier = function () {
    var self = this;
    var updateTimer;

    var linkifyRows = function () {
      // Go through every `td` element and try to link the text contents
      $(self.getElements().table)
        .find("td")
        .each(function (index, element) {
          var tdText = $(element).text();
          $(element).html(window.linkifyStr(tdText));
        });

      // Reset the timer now that everything is linked up
      updateTimer = undefined;
    };

    self.addListener("rowupdate", function () {
      // If there's already a timer cancel that last one before starting new one
      if (updateTimer) {
        clearTimeout(updateTimer);
      }

      updateTimer = setTimeout(linkifyRows, 500);
    });
  };

  window.RowLinkifier = RowLinkifier;
})(window);
